module.exports = __webpack_public_path__ + "13a8c21ec8229421b63297f446ad3afc.fbx";